var exports = {
  "wx": "InboxMessageHeader.module__header___Z3JEN0",
  "LD": "InboxMessageHeader.module__headerLeft___Z3JEN0",
  "$s": "InboxMessageHeader.module__headerActions___Z3JEN0",
  "FW": "InboxMessageHeader.module__headerIconButton___Z3JEN0",
  "nr": "InboxMessageHeader.module__headerIcon___Z3JEN0",
};

module.exports = exports;
